import * as React from 'react';
import { DisplayMessages } from '../DisplayMessages/DisplayMessages';
import * as models from '../../models';
import './CannedMessages.scss';
import { Accordion, Icon } from 'semantic-ui-react';

export interface MessageCategoryProps {
  messages: models.Messages;
  categoryName: string;
  messageCategories: models.MessageCategory[];
  isEditMessagesInProgress: boolean;
  hasSearchQuery: boolean;
  index?: number;
  id?: number;
  editMessageRequest(message: models.Message): void;
  deleteMessageRequest(id: number): void;
  copyMessage(id: number): void;
  cancelEditMessage(): void;
  sortMessageRequest(oldIndex: number, newIndex: number, categoryName: string): void;
  categoryCollapsed(id: number, name: string): void;
  categoryExpand(id: number, name: string): void;
}

export interface MessageCategoryState {
  isActive: boolean;
}

export class MessageCategory extends React.Component<MessageCategoryProps, MessageCategoryState> {

  constructor(props: MessageCategoryProps, state: MessageCategoryState) {
    super(props, state);
    this.state = {
      isActive: false,
    };
  }

  handleClick = () => {
    const isActive = !this.state.isActive;
    if (isActive) {
      this.props.categoryExpand(this.props.id || 0, this.props.categoryName);
    } else {
      this.props.categoryCollapsed(this.props.id || 0, this.props.categoryName);
    }
    this.setState({
      isActive,
    });
  }

  render() {
    const {
      editMessageRequest,
      deleteMessageRequest,
      copyMessage,
      cancelEditMessage,
      sortMessageRequest,
      messages,
      categoryName,
      isEditMessagesInProgress,
      hasSearchQuery,
      messageCategories,
    } = this.props;


    return (
      <div className="cannedMessageGroup">
        <Accordion.Title
          onClick={this.handleClick}
          active={this.state.isActive}
          className="cannedMessageGroupHeader"
        >
          <div className="categoryName" id={`category_${categoryName}`}>
            {categoryName}
            <Icon name="dropdown" />
          </div>
        </Accordion.Title>
        <Accordion.Content active={this.state.isActive}>
          <DisplayMessages
            messageCategories={messageCategories}
            messages={messages}
            categoryName={categoryName}
            editMessageRequest={editMessageRequest}
            deleteMessageRequest={deleteMessageRequest}
            copyMessage={copyMessage}
            cancelEditMessage={cancelEditMessage}
            isEditMessagesInProgress={isEditMessagesInProgress || false}
            sortMessageRequest={sortMessageRequest}
            hasSearchQuery={hasSearchQuery}
          />
        </Accordion.Content>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CannedMessages/MessageCategory.tsx